<template>
  <component @click="toggleCollapsed" :is="tag" :class="className">
    <slot></slot>
  </component>
</template>

<script>
/**
 * @class CardTitle
 *
 * @description this component is a wrapper for bootstrap "panel-title"
 */
export default {
  name: 'CardTitle',
  props: {
    tag: {
      type: String,
      default: 'span',
    },
    className: {
      type: String,
      default: 'panel-title',
    },
  },
  methods: {
    toggleCollapsed() {
      this.$emit('toggle-collapsed')
    },
  },
}
</script>
